import { render, staticRenderFns } from "./registrationForm.vue?vue&type=template&id=c55b6e5a&scoped=true"
import script from "./registrationForm.vue?vue&type=script&lang=js"
export * from "./registrationForm.vue?vue&type=script&lang=js"
import style0 from "./registrationForm.vue?vue&type=style&index=0&id=c55b6e5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c55b6e5a",
  null
  
)

export default component.exports